import { EMPTY_LIST } from '../../constants/common'
import { toFileMultiValue } from '../File'

import { DOC_FLOW_FILE_ADDITIONAL_INFO_TOOLTIP } from './DocFlow.constants'

export function getFileUploadedIds(files) {
  return files.map(item => item.file_id)
}

export function toMultiListFiles(files, t) {
  return files.map(item => ({
    ...toFileMultiValue(item),
    additionalTooltipInfo: t(DOC_FLOW_FILE_ADDITIONAL_INFO_TOOLTIP),
    showTooltip: true,
  }))
}

export function toPreviewFiles(files) {
  return files.map(file => ({
    ...file,
    id: file.file_id || file.id,
  }))
}

export function getDocFlowSendingFilesByRecipientPayload(data) {
  return (data?.items || EMPTY_LIST).map(item => ({
    ...item,
    canDelete: false,
  }))
}
